const RESET_CORRELATION_ID_STORAGE_KEY = 'auth_reset_correlation_id';

export interface AuthInstrumentationHeaderOptions {
    flow: string;
    popupMode?: 'redirect' | 'popup';
    popupAttempted?: boolean;
    popupOpened?: boolean;
    includeResetCorrelationId?: boolean;
}

const getOrCreateResetCorrelationId = (): string => {
    const existing = sessionStorage.getItem(RESET_CORRELATION_ID_STORAGE_KEY);
    if (existing) {
        return existing;
    }
    const generated = crypto.randomUUID();
    sessionStorage.setItem(RESET_CORRELATION_ID_STORAGE_KEY, generated);
    return generated;
};

export const clearResetCorrelationId = (): void => {
    sessionStorage.removeItem(RESET_CORRELATION_ID_STORAGE_KEY);
};

export const buildAuthInstrumentationHeaders = (
    options: AuthInstrumentationHeaderOptions,
): Record<string, string> => {
    const headers: Record<string, string> = {
        'X-Auth-Flow': options.flow,
        'X-Auth-Correlation-Id': crypto.randomUUID(),
    };

    if (options.popupMode) {
        headers['X-Auth-Popup-Mode'] = options.popupMode;
    }
    if (options.popupAttempted !== undefined) {
        headers['X-Auth-Popup-Attempted'] = String(options.popupAttempted);
    }
    if (options.popupOpened !== undefined) {
        headers['X-Auth-Popup-Opened'] = String(options.popupOpened);
    }

    if (options.includeResetCorrelationId) {
        headers['X-Auth-Reset-Correlation-Id'] = getOrCreateResetCorrelationId();
    }

    return headers;
};
